import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react";
import { CSSTransition } from "react-transition-group"; // Material Imports

import withStyles from "@material-ui/core/styles/withStyles";

var FadeUp = /*#__PURE__*/function (_PureComponent) {
  _inherits(FadeUp, _PureComponent);

  var _super = _createSuper(FadeUp);

  function FadeUp() {
    _classCallCheck(this, FadeUp);

    return _super.apply(this, arguments);
  }

  _createClass(FadeUp, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          children = _this$props.children,
          shouldAnimate = _this$props.shouldAnimate;
      return /*#__PURE__*/React.createElement(CSSTransition, {
        timeout: 400,
        classNames: {
          appear: classes.appear,
          appearActive: classes.appearActive
        },
        in: true,
        appear: shouldAnimate
      }, children);
    }
  }]);

  return FadeUp;
}(PureComponent);

var styles = {
  appear: {
    opacity: 0.5,
    transform: "translateY(25%)"
  },
  appearActive: {
    opacity: 1,
    transform: "translateY(0%)",
    transition: "all 400ms ease"
  }
};
export default withStyles(styles)(FadeUp);
FadeUp.defaultProps = {
  shouldAnimate: true
};